export default function formatDate(data) {
    if (data === '' || data === undefined)
        return;

    return data.split('/').reverse().join('-');;
}